import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { DeprecatedFeatureBanner } from '../deprecated-feature-banner/deprecated-feature-banner.component';

const ID = 'deprecated-feature-layout';

export const DeprecatedFeatureLayout = () => {
    const [dismissed, setDismissed] = useState(false);

    return (
        <div
            id={ID}
            className='flex flex-col'>
            {!dismissed && <DeprecatedFeatureBanner onDismiss={() => setDismissed(true)} />}
            <Outlet />
        </div>
    );
};

export default DeprecatedFeatureLayout;
